const exportedObject = {
  consultarUsuariosData: {},
  consultarUsuariosLoading: false,
  consultarUsuariosError: null,

  obtenerRecursosData: {},
  obtenerRecursosLoading: false,
  obtenerRecursosError: null,

  asignarRolData: null,
  asignarRolLoading: false,
  asignarRolError: null,

  removerRolData: null,
  removerRolLoading: false,
  removerRolError: null,

  obtenerUsuarioData: {},
  obtenerUsuarioLoading: false,
  obtenerUsuarioError: null,
};

export default exportedObject;
